import { useEffect } from "react";

/**
 * ReputationHub review widget.
 *
 * Loads the ReputationHub review-widget script once per page (via useEffect,
 * never as a raw string) and renders the review iframe. The script targets
 * iframes with the `lc_reviews_widget` class and auto-resizes them to show all
 * reviews, so no fixed height is set.
 */
export function ReviewsWidget() {
  useEffect(() => {
    const src = "https://reputationhub.site/reputation/assets/review-widget.js";
    if (document.querySelector(`script[src="${src}"]`)) {
      return;
    }
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <iframe
      className="lc_reviews_widget"
      src="https://reputationhub.site/reputation/widgets/review_widget/7dMQRXhpZNOMrhXK0eQA"
      frameBorder="0"
      scrolling="no"
      style={{ minWidth: "100%", width: "100%" }}
      title="Customer Reviews"
    />
  );
}
